var moduleMap = {
	"./WebDxMF": () => {
		return Promise.all([__webpack_require__.e(6752), __webpack_require__.e(1815), __webpack_require__.e(1527), __webpack_require__.e(5929), __webpack_require__.e(6653), __webpack_require__.e(9594), __webpack_require__.e(828)]).then(() => (() => ((__webpack_require__(3597)))));
	},
	"./AppDxSettings": () => {
		return Promise.all([__webpack_require__.e(6752), __webpack_require__.e(1815), __webpack_require__.e(1527), __webpack_require__.e(5929), __webpack_require__.e(6653), __webpack_require__.e(9594), __webpack_require__.e(2885)]).then(() => (() => ((__webpack_require__(45434)))));
	},
	"./AppDxDomainInfo": () => {
		return Promise.all([__webpack_require__.e(6752), __webpack_require__.e(1815), __webpack_require__.e(1527), __webpack_require__.e(5929), __webpack_require__.e(6653), __webpack_require__.e(9594), __webpack_require__.e(1468)]).then(() => (() => ((__webpack_require__(92509)))));
	},
	"./public-path": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__(39691)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});